<template>
  <div>
      <v-select v-model="val" :options="options" :on-change="onChange"></v-select>
  </div>
</template>

<script>
  export default {
    props:['value','options'],
    components:{
    },
    created() {
      this.val = find(this.options, 'value', this.value);
    },
    data () {
      return {
        val: {
          label: '',
          value: ''
        }
      }
    },
    methods: {
      onChange(e) {
        //console.log(e)
        this.val = e;

        this.$emit('update:value', e.value);
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
//@import '~assets/css/lp_main'
</style>
